<template>
  <div :class="$style.topbar">
    <div :class="$style.logo" @click="handleToIndex">
      <img :src="logo" alt="智配管理系统" />
      <h1>智配管理系统</h1>
    </div>
    <div :class="$style.user">
      <span>{{ welcomeText }}，</span>
      <span :class="$style.name">{{ userInfo.realname }}</span>
      <a href="javascript:;" @click="handleLogout">退出</a>
      <span>|</span>
      <a href="javascript:;" @click="dialogVisible = true">修改密码</a>
      <div :class="$style.crm" @click="handleLoginCRM">
        <span>CRM</span>
        <svg :class="$style.icon" class="zp-icon" aria-hidden="true">
          <use xlink:href="#icon-exit" />
        </svg>
      </div>
    </div>
    <PasswdDialog v-model="dialogVisible" />
  </div>
</template>

<script>
import { userLogout, syncLoginCRM } from '@/api/user';
import PasswdDialog from '@/components/passwd-dialog';
import logo from '@/images/logo.png';

export default {
  name: 'Topbar',
  components: {
    PasswdDialog,
  },
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logo,
      dialogVisible: false,
    };
  },
  computed: {
    welcomeText() {
      const hours = new Date().getHours();
      let text = '';
      if (hours < 6) {
        text = '凌晨好';
      } else if (hours < 9) {
        text = '早上好';
      } else if (hours < 12) {
        text = '上午好';
      } else if (hours < 14) {
        text = '中午好';
      } else if (hours < 17) {
        text = '下午好';
      } else {
        text = '晚上好';
      }
      return text;
    },
  },
  methods: {
    handleToIndex() {
      this.$router.push('/');
    },
    async handleLogout() {
      try {
        await this.$confirm('确定要退出系统吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        // 退出登录
        await userLogout();
        // 清除本地登录数据
        localStorage.removeItem(ZP.param.sysParam.token);
        this.$router.replace({ name: 'login' });
      } catch (err) {
        console.log(err);
      }
    },
    async handleLoginCRM() {
      if (this.isLogining) {
        return;
      }
      this.isLogining = true;
      try {
        const url = `${ENV_CONFIG.crmUrl}/index?token=${ZP.randomKey()}`;
        await syncLoginCRM();
        this.isLogining = false;
        window.open(url);
      } catch (err) {
        this.isLogining = false;
        this.$alert('您还未开通CRM系统权限功能，请联系管理员开通CRM系统权限', '提示', {
          confirmButtonText: '知道了',
        });
      }
    },
  },
};
</script>

<style lang="less" module>
@import '~@/styles/vars.less';

.topbar {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 50px;
  padding: 0 10px;
  color: @g-white;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;

  > img {
    width: 36px;
    height: 36px;
  }

  > h1 {
    margin: 2px 0 0 5px;
    font-size: 16px;
  }
}

.name {
  color: @g-main-blue;
}

.user {
  display: flex;
  align-items: center;
  padding: 0 10px;

  a {
    transform: color 0.2s ease;

    &:hover {
      color: @g-main-blue;
    }
  }

  > span {
    margin: 0 5px;

    &:first-child {
      margin: 0;
    }
  }

  > .name {
    margin: 0 20px 0 0;
  }
}

.crm {
  display: flex;
  margin-left: 16px;
  align-items: center;
  font-size: 0;
  cursor: pointer;

  > span {
    margin-right: 2px;
    font-size: 18px;
  }

  :global {
    .zp-icon {
      font-size: 28px;
    }
  }
}
</style>
